<template>
  <mu-popup position="bottom" :open="open" popupClass="kkt-date-picker" @close="close" style="width: 100%">
    <div style="text-align: right; background: #eff2f7">
      <mu-flat-button label="取消" :color="'#4594fb'" @click="close" style="float: left"></mu-flat-button>
      <mu-flat-button label="确认" :color="'#4594fb'" @click="sure"></mu-flat-button>
    </div>
    <mu-content-block style="display: flex;">
      <mu-picker :slots="hourSlots" :visible-item-count="5" :values="hour" @change="dateChange(0, $event, $event)"></mu-picker>
      <mu-picker :slots="slots" :visible-item-count="5" :values="minute" @change="dateChange(1, $event, $event)"></mu-picker>
      <mu-picker :slots="slots" :visible-item-count="5" :values="second" @change="dateChange(2, $event, $event)"></mu-picker>
    </mu-content-block>
  </mu-popup>
</template>

<script>
  export default {
    props: {
      // 禁止秒
      disableS: {
        type: Boolean,
        default () {
          return false
        }
      },
      value: {
        type: String,
        default () {
          return '00:00:00'
        }
      }
    },

    watch: {
      value () {
        this.initDate()
      }
    },

    data () {
      return {
        open: false,
        hour: ['00'],
        hourSlots: [
          {
            width: '100%',
            textAlign: 'center',
            values: Array.apply(null, {length: 24}).map((item, index) => index > 9 ? index :  '0' + index)
          }
        ],
        slots: [
          {
            width: '100%',
            textAlign: 'center',
            values: Array.apply(null, {length: 60}).map((item, index) => index > 9 ? index :  '0' + index)
          }
        ],
        slots: [
          {
            width: '100%',
            textAlign: 'center',
            values: Array.apply(null, {length: 60}).map((item, index) => index > 9 ? index :  '0' + index)
          }
        ],
        minute: ['00'],
        second: ['00'],
        dateValues: ['00', '00', '00']
      }
    },

    created () {
      this.initDate()
    },

    methods: {
      initDate () {
        if (this.value) {
          const arr = this.value.split(':')
          this.hour = [arr[0]] || ['00']
          this.minute = [arr[1]] || ['00']
          this.second = [arr[2]] || ['00']
        }
      },
      show () {
        this.open = true
      },

      close () {
        this.open = false
      },

      sure () {
        this.open = false
        this.$emit('on-change', this.dateValues.join(':'))
      },

      /*
      * 时间选择
      * @param {Number, String}
      */
      dateChange ($index, value,) {
        this.dateValues[$index] = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/KktTimeSelect.vue